import { Report1915Container } from "../../../containers/borrowSystem/Report/Report1915Container";

export function Report1915Page() {
    return (
        <Report1915Container />
    )
}